<!--
 * @模块组件?公共组件: 组件中文名
 * @Comp: <组件名称>
 * @desc: 组件描述
 * @author: 叶锦全
 * @Date: 2022-07-05 09:01:29
 * @param: {Number} [paramName: notRequired?required] - 参数说明
 * @example: 调用示例
 * <compm :param='' @xxx=''></comp>
 * @LastEditors: 叶锦全
 * @LastEditTime: 2022-09-14 13:04:24
-->
<template>
  <div class="xiaxin_msgs">
    <sub-layout-one :navList="navList" :defaultSelect="navList.data[currentId]" @itemSelect="itemSelect"></sub-layout-one>
  </div>
</template>
<script>
import subLayoutOne from './common/subLayoutOne.vue'
export default {
  components: { subLayoutOne },
  data() {
    return {
      currentId: 0,
      navList: {
        title: '办事大厅',
        data: [
          {
            id: 0,
            icon: 'appstore',
            name: '入会流程',
            show_sub: false,
            path: '/home/office_hall/membership_process',
            sons: []
          }]
      }
    }
  },
  created() {
  },
  methods: {
    itemSelect(item) {
      console.log(item)
      this.currentId = item.id
      // this.$router.push(`/home/about/${item.id}`)
    }
  }
}
</script>
